/**
 * @param scrollDuration - ignored (native smooth scroll does not support custom duration)
 * @param selector
 */
export function scrollToTopEffect(_scrollDuration: number, selector: string) {
    const element = document.querySelector(selector);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    } else {
        console.warn(`Could not smooth-scroll to ${selector} as the element was not found`);
    }
}

/**
 * @param scrollDuration - ignored (native smooth scroll does not support custom duration)
 * @param selector
 * @param offset
 */
export function scrollToTopOffsetEffect(_scrollDuration: number, selector: string, offset: number) {
    const element = document.querySelector(selector);
    if (element) {
        const top = element.getBoundingClientRect().top + window.scrollY + offset;
        window.scrollTo({ top, behavior: 'smooth' });
    } else {
        console.warn(`Could not smooth-scroll (with offset) to ${selector} as the element was not found`);
    }
}
